import { render, staticRenderFns } from "./ChartCategory.vue?vue&type=template&id=2924ed16&scoped=true&"
import script from "./ChartCategory.vue?vue&type=script&lang=js&"
export * from "./ChartCategory.vue?vue&type=script&lang=js&"
import style0 from "./ChartCategory.vue?vue&type=style&index=0&id=2924ed16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924ed16",
  null
  
)

export default component.exports